import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import CustomerSearch from '../../search/CustomerSearch';

export default function FormInputCustomerSearch(props) {
  return <FormInputSearch {...props} searchComponent={CustomerSearch} />;
}
